import {css} from 'styled-components'

export const tableStyle = css`
  overflow: auto;
  max-width: 50rem;
  width: 100%;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`

export const trStyle = css`
  border-bottom: solid ${({theme}) => theme.colors.main.grayLight} 1px;
  padding: 1rem 0;
`

export const tdStyle = css`
  padding: 0.5rem 0;
`

export const thStyle = css`
  padding: 1rem 0;
`
